
import { Component, Prop, Vue } from 'vue-property-decorator'

import BacButton from '@/components/BacButton.vue'
import BacModal from '@/components/BacModal.vue'
import BacInput from '@/components/BacInput.vue'
import { User } from '../../lib/models/User'
import UIkit from 'uikit'
import VuePassword from 'vue-password'

@Component({
  components: {
    BacButton,
    BacModal,
    BacInput,
    VuePassword
  }
})
export default class ChangePasswordModal extends Vue {
  @Prop({ default: () => new User() }) user!: User

  zxcvbn = null

  newPassword = ''
  newPasswordConfirm = '';

  get strength () {
    if (!this.newPassword) {
      return 0
    }
    if (!this.zxcvbn) {
      return 0
    }
    return (this.zxcvbn as any)(this.newPassword).score
  }

  async changePassword () {
    if (this.newPassword) {
      if (this.strength <= 2) {
        UIkit.notification({
          message:
            'Passwort zu schwach, bitte ein stärkeres auswählen!',
          status: 'warning',
          timeout: 5000,
          pos: 'bottom-center'
        })
        return
      }
      if (this.newPassword !== this.newPasswordConfirm) {
        UIkit.notification({
          message:
            'Passwort stimmt nicht mit Passwort Kontrolle überein!',
          status: 'warning',
          timeout: 5000,
          pos: 'bottom-center'
        })
        return
      }
    }

    await this.user.changePassword(this.newPassword)
    this.newPassword = ''
    this.newPasswordConfirm = ''
    UIkit.notification({
      message: 'Passwort erfolgreich geändert',
      status: 'success',
      timeout: 5000,
      pos: 'bottom-center'
    })
    UIkit.modal('#change-password-modal').hide()
  }

  mounted () {
    this.loadZxcvbn()
    setTimeout(() => { this.newPassword = '' }, 100)
  }

  async loadZxcvbn () {
    this.zxcvbn = (await import('zxcvbn')).default
  }
}
